<template>
  <div>
    <div class="meter-box container lib__no-padding row">
      <div :class="'col-xs-12 col-sm-12 col-md-12 col-lg-12 lib__no-margin lib__no-padding'">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row meter-box top-text-container">

          <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 meter-box title">
            <span class="lib__text-gray-500 lib__text-weight-400 lib__text-no-uppercase"
              v-html="$t('meter.electricityPackage.packageLabel')"></span>
            <span class="lib__text-weight-700 lib__text-uppercase"
              v-html="meter.package && meter.package.key !== '69+' ? ` ${meter.package && meter.package.key}` : ` ${$t('meter.electricityPackage.69+')}`"></span>



          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 row meter-box price-container">
            <div v-if="!isFree && !isPriceToBeDetermined"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row lib__no-margin lib__no-padding">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box price">
                {{ getVATPriceForPackage() }} €
              </div>
            </div>
            <div v-if="buildingType === 'building' || (isPriceToBeDetermined && !isFree)"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row lib__no-margin lib__no-padding">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box price-free">
                {{ $t('new-connection-cmh.offering-selection-step.priceToBeEstimated') }}
              </div>
            </div>
            <div v-if="isFree && !isPriceToBeDetermined"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row lib__no-margin lib__no-padding">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box price-free">
                {{ $t('new-connection-cmh.offering-selection-step.free') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row meter-box top-text-container">

          <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 meter-box">
            <p class="lib__text-theme lib__text-gray-500 lib__text-weight-500">
              <span>{{ meter.count }} x {{ $tc('meter-box.electricalMeter', getMeterCount()) }},</span>
              <span v-if="buildingType === 'building'">{{ $t('meter.buildingDestination.' + meter.destination) }}, </span>
              <span v-if="meter.package && (meter.package.key === 'Essentiel' || meter.package.key === 'Confort')">
                {{ $t('meter.phase.' + meter.connectionType) }}
              </span>
            </p>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 meter-box price-free">
            <p class="">{{ $t('meter.includingVATPrice') }}
            </p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row meter-box bottom-text-container">
          <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 meter-box description-margin readonly ">
            <span class="lib__text-theme lib__text-gray-500" v-if="meter.package && meter.package.key !== '69+'">{{
              $t('meter.maximumPowerGuaranteed') }}
              <span class="lib__text-weight-700">{{
                meter.package.maximumPower.kiloVoltAmpere }} {{
    $t('energyProduction.kva') }} </span>
            </span>

            <span v-if="meter.package && meter.package.key === '69+'">{{ $t('meter.maximumPowerWanted') }}
              <span class="lib__text-theme lib__text-weight-700">{{ meter.wantedPower
              }} {{
  $t('energyProduction.kva') }} </span>
            </span>
            <sup class="lib__tooltips lib__tooltips--top-right">
              <span class="lib__tooltips__trigger" @click="guaranteedMaximumPowerModalOpen = true">
                <i class="fas fa-info"></i>
              </span>
            </sup>
          </div>
          <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 meter-box price-free">
            {{ $t('meter.uniquePaimentLabel') }}
          </div>
        </div>
      </div>
    </div>
    <GuaranteedMaximumPowerModal v-model="guaranteedMaximumPowerModalOpen" />

  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import GuaranteedMaximumPowerModal from '@/components/display/CmhNewConnection/GuaranteedMaximumPowerModal.vue'
import { vatService } from '@/services/index'
import { PackagedElectricityMeter } from '@/models'
import { BuildingType } from '@/models/building-type'
import { pricingService } from '@/services/pricing-service'

@Component({
  name: 'package-meter-summarized',
  components: {
    GuaranteedMaximumPowerModal
  }
})
export default class PackageMeterSummarized extends Vue {
  @Prop({ type: Object, required: true }) public meter!: PackagedElectricityMeter
  @Prop({ type: Boolean, required: true }) public isPriceToBeDetermined!: boolean
  @Prop({ type: String, required: true }) public applicableVAT!: string
  @Prop({ type: String, required: false }) buildingType!: BuildingType

  public guaranteedMaximumPowerModalOpen: boolean = false
  public isFree: boolean = false

  getVATLabel(): string {
    return vatService.getVatLabel(this.applicableVAT!)
  }

  getVATPriceForPackage(): string {
    return pricingService.formatNumberToLocaleStringFormat(vatService.getVATPriceForPackage(this.meter!, this.applicableVAT!, this.buildingType))
  }

  getMeterCount(): number {
    return this.meter.count ? this.meter.count : 0
  }
}
</script>

<style scoped>
.meter-box.container {
  box-sizing: border-box;
  border: 1px solid #c1c7cc;
  border-radius: 4px;
  margin: 20px auto;
}

@media screen and (min-width: 577px) {
  .meter-box.title {
    height: 25px;
    width: 200px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 18px;
  }

  .meter-box.top-text-container {
    margin: 10px 0px 0px;
  }

  .meter-box.price {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-free {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-container {
    padding: 0px;
  }

  .meter-box.bottom-text-container {
    margin: 0px 0px 10px;
  }

}

@media screen and (max-width: 576px) {
  .meter-box.title {
    width: 100%;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 18px;
  }

  .meter-box.top-text-container {
    margin: 20px 0px 0px;
  }

  .meter-box.price {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-free {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-container {
    padding: 0px;
  }

  .meter-box.bottom-text-container {
    margin: 10px 0px 0px;
  }

  .meter-box.readonly.description-margin {
    margin-bottom: 20px;
  }
}
</style>